<div class="bary-table-list pb-4 table-responsive">
  <table mdbTable [hover]="true" [small]="true" class="overflow-auto d-block d-sm-table mx-100">
    <thead>
      <tr [(ascending)]="pagination.reverse" [(predicate)]="pagination.predicate" jhiSort>
        <th scope="col" jhiSortBy="lastName">
          <span jhiTranslate="userManagement.lastName">Nom</span>
        </th>
        <th scope="col" jhiSortBy="firstName">
          <span jhiTranslate="userManagement.firstName">Prénom</span>
        </th>
        <th scope="col" jhiSortBy="email">
          <span jhiTranslate="userManagement.email">Email</span>
        </th>
        <th scope="col" jhiSortBy="createdDate">
          <span jhiTranslate="userManagement.createdDate">Created Date</span>
        </th>
        <th scope="col" class="text-center">
          <span jhiTranslate="userManagement.remboursement">Remboursement</span>
        </th>
      </tr>
    </thead>
    <tbody *ngIf="users">
      <tr mdbTableRow *ngFor="let user of users">
        <td>{{ user.lastName }}</td>
        <td>{{ user.firstName }}</td>
        <td>{{ user.email }}</td>
        <td>{{ user.createdDate | date: 'dd/MM/yy' }}</td>
        <td class="text-center">
          <mdb-checkbox
            *ngIf="user.id"
            (change)="changeRight(user)"
            [checked]="
              (user.rights.includes(WRITE_REFUND) && !baryRightService.customerIdsChangeRight.has(user.id)) ||
              (!user.rights.includes(WRITE_REFUND) && baryRightService.customerIdsChangeRight.has(user.id))
            "
          ></mdb-checkbox>
        </td>
      </tr>
      <tr [hidden]="users && users.length > 0">
        <td colspan="12" class="table-data-not-found">
          <div class="text-center">
            <p class="lead p-5" jhiTranslate="LABEL.NO_RESULT">No Moderators</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
